import React, { useState } from 'react';
import {  } from 'react-icons/fa'; 
import {  } from 'react-icons/gi'; 
const Contact = () => {
  return (
    <>
      <div class="parent-about">
        <h1>Contact</h1>
      </div>
      <div class="parent-contact">
        <div class="child-contact">
            <p>I'm Always Open To Discussing Product</p>
            <h2>design work or partnerships.</h2>
            <label>Name</label><br></br>
            <input type="text" id="name" class="input-field" placeholder='Name' required></input>
            <span class="underline"></span>
            <label>Email</label><br></br>
            <input type="text" id="name" class="input-field" placeholder='Email' required></input>
            <span class="underline"></span>
            <label>Message</label><br></br>
            <textarea type="text" id="name" class="input-field" placeholder='Message' required></textarea>
            <button>Submit</button>
        </div>
      </div>

    </>
  );
};

export default Contact;
